import { put, select } from 'redux-saga/effects'
import { takeLatest } from '@redux-saga/core/effects'
import { getQuickActionsSelector } from '../selectors/quickActions.selector'
import { saveRescue } from '../../procedures/rescue/store/rescue.actions'
import { QuickActionsConstants } from '../store/quickActions.constants'

export function* setRescueQuickActionTimeLineRow() {
  const quickActionsObject = yield select(getQuickActionsSelector)
  const { addRescueToTimeline } = quickActionsObject
  if (addRescueToTimeline) {
    yield put(saveRescue())
  }
}

export function* setRescueQuickActionTimeLineRowSaga() {
  yield takeLatest([QuickActionsConstants.SET_ADD_RESCUE_TO_TIMELINE], setRescueQuickActionTimeLineRow)
}
